import { render, staticRenderFns } from "./profile-juridical.vue?vue&type=template&id=de2075bc&scoped=true"
import script from "./profile-juridical.vue?vue&type=script&lang=js"
export * from "./profile-juridical.vue?vue&type=script&lang=js"
import style0 from "./profile-juridical.vue?vue&type=style&index=0&id=de2075bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2075bc",
  null
  
)

export default component.exports